import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import TaskGuideCard from "./TaskGuide/TaskGuideCard";
import QuickLinks from "./QuickLinks";

/**
 * Focus Guide Section — displays the guide orb and quick actions.
 * On desktop: quick actions flanking the orb (2 on each side).
 * On mobile: orb on top, links below.
 */
const FocusGuideSection = ({ onGuideOpen, onCreateTask }) => {
  const taskSet = useSelector((state) => state.tasks.taskSet);
  const taskCount = useMemo(
    () => Object.values(taskSet).filter((t) => !t.completed).length,
    [taskSet],
  );

  return (
    <Box className="focus-guide-section">
      <Box className="focus-guide-section__content">
        <Box className="focus-guide-section__links focus-guide-section__links--left">
          <QuickLinks side="left" onCreateTask={onCreateTask} />
        </Box>
        <Box className="focus-guide-section__orb">
          <TaskGuideCard onClick={onGuideOpen} hasNoTasks={taskCount === 0} />
        </Box>
        <Box className="focus-guide-section__links focus-guide-section__links--right">
          <QuickLinks side="right" onCreateTask={onCreateTask} />
        </Box>
      </Box>
      {/* Mobile: full quick links below the orb */}
      <Box className="focus-guide-section__mobile-links">
        <QuickLinks onCreateTask={onCreateTask} />
      </Box>
    </Box>
  );
};

export default FocusGuideSection;
